import $ from "jquery";
import "slick-carousel";

// Ford Pass Slider
const testSlider = 'ford-pass-slider';

// Applies a base theme (group of classes) to the indvidual slider dots
$(`.${testSlider}`).on('init', function (event, slick) {
  if (slick.$dots) {
    const dots = slick.$dots.find("li");
    const theme = $(`.controls-dots-${testSlider}`).data("theme");
    dots.addClass('slick-dot ' + theme);
  }
});

$(`.${testSlider}`).slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  dots: true,
  appendDots: $(`.controls-dots-${testSlider}`),
  nextArrow: $(`.controls-next-${testSlider}`),
  prevArrow: $(`.controls-prev-${testSlider}`),
});

// Home Hero Slider
const testSlider2 = 'promo-slider';

// Applies a base theme (group of classes) to the indvidual slider dots
$(`.${testSlider2}`).on("init beforeChange", function (event, slick) {
  if (slick.$dots) {
    const dots = slick.$dots.find("li");
    const theme = $(`.controls-dots-${testSlider2}`).data("theme");
    dots.addClass('slick-dot ' + theme);
  }
});

$(`.${testSlider2}`).slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  dots: true,
  appendDots: $(`.controls-dots-${testSlider2}`),
  nextArrow: $(`.controls-next-${testSlider2}`),
  prevArrow: $(`.controls-prev-${testSlider2}`),
  adaptiveHeight: true,
  autoplay: false,
});